module.exports = __webpack_public_path__ + "static/media/hear_results_1_mobile.d5b5cd73.jpg";